export default {
    appreciation: {
        label: 'Appreciate',
        saved_label: 'Appreciated',
        saving: 'Saving…',
        hint: 'Send a little love to the people behind the latest edit',
        saved: 'Appreciation saved. Thanks for recognizing the people behind this video!',
        error: 'Your appreciation could not be saved. Please try again.',
        new_edit: 'A newer edit is ready. Click again to appreciate the latest version.',
        dialog_title: 'Celebrate this edit',
        dialog_description: 'A little recognition goes a long way. Add a personal note, or let your appreciation say it all.',
        comment_label: 'Add a comment',
        optional: 'Optional',
        comment_placeholder: 'What made this edit special? A thoughtful detail, a quick turnaround, a happy client…',
        shared_with: 'Shared with the team behind this edit',
        character_count: '{count} / {max}',
        send: 'Send appreciation',
        send_without: 'Send without a comment',
        cancel: 'Cancel',
        close: 'Close',
        review_latest: 'Close and review the latest edit',
    },
    // A
    attachHeadshot: 'Attach headshot',
    audio_file: 'Audio file',
    audio_only: 'Audio',
    audio_playing: 'Playing audio',

    // C
    content_flagged_as_incompleted: 'Content has been flagged as incomplete',

    // F
    files: 'Files',
    flag_as_incompleted: 'Under Review',
    needs_info_internal_only: 'Internal note',
    needs_info_internal_only_hint: 'Only the MarketScale team and editors see this. The customer is not emailed.',
    needs_info_reviewing: 'MarketScale is reviewing',

    // M
    move_to_human_qc: 'Move to Human QC',

    // P
    proofing: 'Proofing',

    // R
    retry_agent_qc: 'Retry Agent QC',
    ready_to_edit: 'Resume My Edit',

    // S
    select_reason_for_flagging: 'Select reason(s) for flagging',
}
